// React
import React from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {TextField, Grid, Button} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiVectorPolylineEdit,
} from '@mdi/js';

// helpers
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';

// Type

type Props = {
  data: any;
  updateZone: (body: any) => void;
  error: any;
  onClose: () => void;
};

type Inputs = {
  name: string;
  aisleCount: number;
  columnCount: number;
  unitCount: number;
  rowCount: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  }),
);

export default function Edit(props: Props) {
  const classes = useStyles();
  const {register, handleSubmit, watch, errors} = useForm<Inputs>();
  const onSubmit = ({unitCount}: Inputs) => {
    props.updateZone({
      unitCount,
      id: props.data.id
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4} alignItems="flex-start">
        <Grid container item xs={12} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiVectorPolylineEdit}
                size={1}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                type="number"
                fullWidth
                id="unitCount"
                name="unitCount"
                defaultValue={props.data.unitCount}
                label="تعداد یونیت"
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /[0-9]/,
                    message: 'مقدار وارد شده باید عدد باشد',
                  },
                })}
                error={errors.unitCount && true}
              />
            </div>
          </div>
        </Grid>
        <Grid item container xs={8}>
          <Button
            fullWidth
            type="submit"
            size="large"
            data-cy="search"
            autoFocus
            variant="contained"
            color="secondary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                .length === 0
            }
          >
            {`ویراش طبقه`}
          </Button>
        </Grid>
        <Grid item container xs={4}>
          <Button
            fullWidth
            variant="contained"
            onClick={props.onClose}
            size="large"
            data-cy="search"
          >
            {`انصراف`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
